// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SettingsConsentForm__wrapper__3Ok74","submitResult":"SettingsConsentForm__submitResult__YVGxn","actionWrapper":"SettingsConsentForm__actionWrapper__u6Mju","wrapper2faOptions":"SettingsConsentForm__wrapper2faOptions__3jt4p","previewFrame":"SettingsConsentForm__previewFrame__84x-w","checkoutButton":"SettingsConsentForm__checkoutButton__dnkjr","active":"SettingsConsentForm__active__2epAt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SettingsConsentForm/SettingsConsentForm.css
// module id = 1894
// module chunks = 0